module.exports = __webpack_public_path__ + "img/benefit-logo-3.640c7ef5.svg";